import { Button } from "@mantine/core";
import { IconShieldLock } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export default function ClientMismatchPage() {
  const { t } = useTranslation();

  const handleBack = () => {
    window.location.href = "/";
  };

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center max-w-md">
        <IconShieldLock size={64} className="text-gray-400" />
        <h1 className="text-3xl font-bold text-black">
          {t("auth.clientMismatch.title")}
        </h1>
        <p className="text-gray-600">
          {t("auth.clientMismatch.description")}
        </p>
        <Button
          color="black"
          variant="outline"
          onClick={handleBack}
        >
          {t("auth.clientMismatch.goBack")}
        </Button>
      </div>
    </div>
  );
}
